module.exports = __webpack_public_path__ + "img/Bougies_par_couleur.e47b936.jpg";